var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"ripple",rawName:"v-ripple",value:({
    center: true,
    class: _vm.isCircle ? 'rounded-circle' : 'rounded-lg',
  }),expression:"{\n    center: true,\n    class: isCircle ? 'rounded-circle' : 'rounded-lg',\n  }"}],class:[
    ' d-flex flex-column justify-center align-center cursor-pointer font-weight-bold text-center',
    _vm.color,
    _vm.isCircle ? 'fab rounded-circle' : 'rounded-lg',
    _vm.applyDashedBorder ? 'dashed-outline-border' : 'outlined-border',
  ],style:(`width: ${_vm.containerWidth}px; height: ${_vm.containerHeight}px;z-index: ${this.zIndex}; position: ${this.cssPosition}`),on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',[_c('v-icon',[_vm._v("mdi-image-outline")])],1),_c('div',{staticClass:"grey--text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }